import { useTheme } from '@emotion/react';
import {
  IconBallAmericanFootball,
  IconBallBaseball,
  IconBallBasketball,
  IconBallFootball,
  IconGolf,
  IconIceSkating,
} from '@tabler/icons-react';

import IconCards from '~/domains/design-system/icons/IconCards';

export function IconMapByLeague({
  leagueId,
  size,
  color,
  ...props
}: {
  leagueId: string;
  size: number;
  color?: string;
}) {
  const theme = useTheme();
  const iconColor = color ?? theme.colors.blue[4];

  switch (leagueId) {
    case 'popular':
      return <IconCards color={iconColor} size={size + 2} />;
    case 'pga':
      return <IconGolf color={iconColor} size={size} {...props} />;
    case 'wc':
      return <IconBallFootball color={iconColor} size={size} {...props} />;
    case 'nfl':
    case 'ncaaf':
      return <IconBallAmericanFootball color={iconColor} size={size} {...props} />;
    case 'mlb':
      return <IconBallBaseball color={iconColor} size={size} {...props} />;
    case 'nba':
    case 'ncaab':
      return <IconBallBasketball color={iconColor} size={size} {...props} />;
    case 'nhl':
      return <IconIceSkating color={iconColor} size={size} {...props} />;
    default:
      return null;
  }
}
